const meta = {
  'service-pages': 'Service pages',
  'service-exploration': 'Service exploration',
};

export default meta;
